import { Link } from "@repo/ui/Link/index";
import type { FC, ReactNode } from "react";
import { imageLinks } from "../../helpers/imageLinks.js";

interface SignInPageShellProps {
  children: ReactNode;
  /** Optional content rendered below the card (e.g. a "Back" link). */
  belowCard?: ReactNode;
}

/**
 * Shared chrome for the pre-auth sign-in screens: a fixed logo, a centered white
 * card, and the Terms/Privacy footer. Used by both the standalone sign-in screen
 * and the invitation sign-in screen so the layout stays in one place.
 */
export const SignInPageShell: FC<SignInPageShellProps> = ({
  children,
  belowCard,
}) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 sm:px-6 lg:px-8">
      <img
        src={imageLinks.LOGO_BLUE}
        alt="Alpharun"
        className="fixed top-8 mx-auto h-5"
      />
      <div className="w-full max-w-md">
        <div className="rounded-lg bg-white px-6 py-10 shadow-sm sm:rounded-lg">
          {children}
        </div>
        {belowCard}
      </div>
      <div className="absolute bottom-3 w-full px-4">
        <p className="text-center text-xs text-muted-foreground">
          By signing in, you agree to Alpharun&apos;s{" "}
          <Link href="https://assets.alpharun.com/terms_of_service.pdf">
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link href="https://assets.alpharun.com/privacy_policy.pdf">
            Privacy Policy
          </Link>
          .
        </p>
      </div>
    </div>
  );
};
